var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user_svg__a)",
    stroke: "#fff",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.563 17.55v-.863a4.314 4.314 0 0 1 4.312-4.312 4.314 4.314 0 0 1 4.313 4.313v.862",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 12.375a2.584 2.584 0 0 0 2.588-2.587A2.584 2.584 0 0 0 11.875 7.2a2.584 2.584 0 0 0-2.588 2.588 2.584 2.584 0 0 0 2.588 2.587Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 21a8.625 8.625 0 1 0 0-17.25 8.625 8.625 0 0 0 0 17.25Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgUser;